module.exports = __webpack_public_path__ + "img/iriomote_17.3b4da22e.jpg";